import { useState, useEffect, useRef } from 'react';
import { Typography } from '@material-ui/core';
import moment from 'moment';
import { useSelector } from 'react-redux';
import './styles.css';

import { getNotificationList } from '../../api/notification';
import { notificationBellIcon } from './const';
import PrimaryLoader from '../PrimaryLoader';
import {
  getGlCheckerNotification,
  getGlCheckerNotificationById,
} from '../../api/ledgers';
import { useHistory } from 'react-router-dom';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const NavbarNotification = () => {
  const listInnerRef = useRef();
  const { profileData } = useSelector(({ auth }) => auth);

  // const id = profileData.employee_no;

  // const [notificationData, setNotificationData] = useState([]);
  const [counter, setCounter] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [selectedNotif, setSelectedNotif] = useState({});
  const [refetch, setRefetch] = useState(false);
  // const [total, setTotal] = useState({});
  // const [pageSize, setPageSize] = useState(0);

  const [glCheckerNotificationData, setGlCheckerNotificationData] = useState(
    [],
  );

  const history = useHistory();

  const [form, setForm] = useState({
    page: 1,
    page_size: 5, // limit
    order_by: 'created_at',
    direction: 'asc',
    search: '',
  });

  // useEffect(() => {
  //   loadNotificationList(form, 0);
  // }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoading(true);
      loadGlCheckerNotification(form);
    }, 180000);

    setLoading(true);
    loadGlCheckerNotification(form);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setLoading(true);
    loadGlCheckerNotification((prev) => ({ ...prev, ...form }));
  }, [selectedNotif]);

  // const loadNotificationList = async (formData, pageSize) => {
  //   let no_of_pages = pageSize * formData.page_size;
  //   setLoading(true);
  //   setPageSize((prevPageSize) => prevPageSize + 1);
  //   try {
  //     await new Promise((r) => setTimeout(r, 1000));

  //     let res = await getNotificationList(
  //       { ...formData, page: no_of_pages },
  //       id,
  //     );

  //     const { code, result, total_rows } = res.data.response;

  //     setLoading(false);
  //     if (code !== '00000') {
  //       return;
  //     }

  //     setNotificationData([...notificationData, ...result]);
  //     setCounter(total_rows);
  //     setTotal(total_rows);
  //   } catch (error) {
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const onScroll = (e) => {
    if (currentPage < lastPage) {
      if (listInnerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
        // const total_pages = total / form.page_size;
        // const bottom =
        //   e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

        if (scrollHeight - Math.round(scrollTop + clientHeight) <= 1) {
          const newForm = {
            ...form,
            page: (form.page = form.page + 1),
          };

          setForm(newForm);
          loadGlCheckerNotification(newForm);
          // if (pageSize < Math.ceil(total_pages)) {
          //   loadNotificationList(form, pageSize);
          // } else {
          //   return;
          // }
        }
      }
    }
  };

  const loadGlCheckerNotification = async (form) => {
    try {
      const res = await getGlCheckerNotification(form);

      const { code, result, un_read, current_page, last_page } =
        res.data.response;

      if (code === '00000') {
        // setGlCheckerNotificationData((prev) => [...prev, ...result]);
        setGlCheckerNotificationData((prev) => {
          const newNotif = result.filter(
            (newItem) => !prev.some((item) => item.id === newItem.id),
          );

          return [...prev, ...newNotif];
        });

        setCounter(un_read);
        setLoading(false);
        setCurrentPage(current_page);
        setLastPage(last_page);
        setRefetch(true);
      }
    } catch (error) {}
  };

  const handleRedirectToGlChecker = async (notif) => {
    setLoading(true);
    setGlCheckerNotificationData([]);

    history.push(
      `/finance-and-accounting/beginning-and-ending-balance-checker?param1=${notif.param.parameter_1}&param2=${notif.param.parameter_2}`,
    );

    const res = await getGlCheckerNotificationById(notif.id);

    const { code, result } = res.data.response;

    if (code === '00000') {
      setSelectedNotif((notif) => ({ ...notif, result }));
    }

    return;
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  const renderIcon = () => {
    return (
      <div className="nav-item dropdown d-none d-md-flex me-3">
        <a
          href="/#"
          id="navlink"
          className="nav-link px-0"
          data-bs-toggle="dropdown"
          tabIndex="-1"
          aria-label="Show notifications"
        >
          {notificationBellIcon}

          {counter > 0 ? (
            !loading ? (
              <span className="badge bg-red">{counter}</span>
            ) : (
              <span className="badge bg-red">...</span>
            )
          ) : null}
        </a>
        <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow navbar-notification">
          <div
            className="nn-content"
            onScroll={(e) => onScroll(e)}
            ref={listInnerRef}
          >
            {glCheckerNotificationData.length > 0
              ? glCheckerNotificationData.map((rows, key) =>
                  renderBodyGlNotification(rows, key),
                )
              : !loading && (
                  <Typography className="text-center text-secondary">
                    {' '}
                    No Notification{' '}
                  </Typography>
                )}
          </div>
          {loading && (
            <div className="position-relative p-4">
              <PrimaryLoader visible={true} />
            </div>
          )}
        </div>
      </div>
    );
  };

  // const renderBody = (data, key) => {
  //   return (
  //     <a id="data" className="dropdown-item notification-item" key={key}>
  //       {data.text}
  //       <Typography className="nn-timestamp">
  //         {moment(data.created_at).startOf('hour').fromNow()}
  //       </Typography>
  //     </a>
  //   );
  // };

  const renderBodyGlNotification = (data, key) => {
    // console.log(`${data.id} - ${data.transaction}`);

    let unread = (
      <button
        id="data"
        className="dropdown-item notification-item text-wrap unread"
        key={key}
        onClick={() => {
          handleRedirectToGlChecker(data);
        }}
      >
        {data.text}
        <LightTooltip
          title={
            <div>
              {data.transaction.reference} <br />
              {data.transaction.status}
            </div>
          }
          arrow
        >
          <ErrorOutlineOutlinedIcon fontSize="small" className="ml-2" />
        </LightTooltip>
        <Typography className="nn-timestamp">{data.created_at}</Typography>
      </button>
    );

    let read = (
      <button
        id="data"
        className="dropdown-item notification-item text-wrap"
        key={key}
        onClick={() => {
          handleRedirectToGlChecker(data);
        }}
      >
        {data.text}
        <LightTooltip
          title={
            <div>
              {data.transaction.reference} <br />
              {data.transaction.status}
            </div>
          }
          arrow
        >
          <ErrorOutlineOutlinedIcon fontSize="small" className="ml-2" />
        </LightTooltip>
        <Typography className="nn-timestamp">{data.created_at}</Typography>
      </button>
    );

    return data.is_read == 0 ? unread : read;
  };

  return renderIcon();
};

export default NavbarNotification;
